import { blogCovers, type BlogCoverKey } from "@/lib/blog-covers";

export function BlogCover({ cover, className }: { cover: BlogCoverKey; className?: string }) {
  const content = blogCovers[cover];

  return (
    <svg
      viewBox="0 0 1200 630"
      role="img"
      aria-labelledby={`${cover}-title ${cover}-description`}
      className={className}
    >
      <title id={`${cover}-title`}>{content.headlineLines.join(" ")}</title>
      <desc id={`${cover}-description`}>{content.subhead}</desc>
      <rect width="1200" height="630" fill="#F5F1E9" />
      <rect width="14" height="630" fill="#9C3A11" />
      <text
        x="112"
        y="116"
        fill="#9C3A11"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="23"
        fontWeight="700"
        letterSpacing="4"
      >
        {content.eyebrow}
      </text>
      <text
        x="112"
        y="242"
        fill="#1A2E21"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="70"
        fontWeight="700"
        letterSpacing="0"
      >
        {content.headlineLines.map((line, index) => (
          <tspan key={line} x="112" dy={index === 0 ? 0 : 76}>
            {line}
          </tspan>
        ))}
      </text>
      <text
        x="112"
        y="430"
        fill="#828E78"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="32"
        fontWeight="400"
        letterSpacing="0"
      >
        {content.subhead}
      </text>
      <rect x="112" y="470" width="140" height="3" fill="#9C3A11" />
      <g transform="translate(1022 444)">
        <circle cx="62" cy="62" r="60" fill="#F5F1E9" stroke="#9C3A11" strokeWidth="2" />
        <text
          x="62"
          y="58"
          textAnchor="middle"
          fill="#1A2E21"
          fontFamily="Arial, Helvetica, sans-serif"
          fontSize="34"
          fontWeight="700"
          letterSpacing="2"
        >
          FS
        </text>
        <text
          x="62"
          y="94"
          textAnchor="middle"
          fill="#9C3A11"
          fontFamily="Arial, Helvetica, sans-serif"
          fontSize="34"
          fontWeight="700"
          letterSpacing="2"
        >
          GE
        </text>
        <text
          x="62"
          y="149"
          textAnchor="middle"
          fill="#828E78"
          fontFamily="Arial, Helvetica, sans-serif"
          fontSize="18"
          fontWeight="700"
          letterSpacing="3"
        >
          FSGE
        </text>
      </g>
    </svg>
  );
}